/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import * as API from '../../http/api';
import * as FUNC from '../../functions/functions';
import * as Modals from './../modals';
import { openlightbox } from '../../util/Functions';
import { IconButton, Tooltip } from '@mui/material';
import { Edit, ErrorOutline } from '@mui/icons-material';

const Address = (props) => {
    const history = useHistory();
    const [active, setActive] = useState('shipping');
    const [stateLabel, setStateLabel] = useState({
        shipping: '',
        invoicing: ''
    });
    const [content, setContent] = useState({});
    const info = [
        { key: "street", label: "Calle y número" },
        { key: "locality", label: "Colonia" },
        { key: "town", label: "Alcaldía" },
        { key: "state", label: "Estado" },
        { key: "zip", label: "Código postal" },
        { key: "reference", label: "Referencia" },
    ];
    const legacy = [
        { key: "street", label: "Calle" },
        { key: "intnum", label: "Número interior" },
        { key: "extnum", label: "Número exterior" },
        { key: "locality", label: "Colonia" },
        { key: "town", label: "Alcaldía" },
        { key: "state", label: "Estado" },
        { key: "zip", label: "Código postal" },
        { key: "reference", label: "Referencia" },
        { key: "country", label: "País" },
    ];
    
    useEffect(() => {
        let labelShip = '';
        let labelInvo = '';
        for(let i = 0; i<props.catalogs.states.length; i++){
            if(props.catalogs.states[i]['k'] == props.content.address.shipping?.state){
                labelShip = props.catalogs.states[i]['v'];
            }
            if(props.catalogs.states[i]['k'] == props.content.address.invoicing?.state){
                labelInvo = props.catalogs.states[i]['v'];
            }
        }
        if(props.config?.fields){
            dataWidget();
        }
        setStateLabel({
            shipping: labelShip,
            invoicing: labelInvo
        });
    }, [props.content]);

    const changeTab = (name) => {
        setActive(name);
    }

    const dataWidget = async () => {
        let x = await FUNC.filter(props.content, props.config?.fields?.in);
        x = await FUNC.exclude(x, props.config.fields.ex);
        setContent(JSON.parse(JSON.stringify(x)));
    }

    const validation = async (data, type) => {
        let payload = {
            customerUuid: props.content.customer_uuid,//TWO_FACTOR_AUTH
            factorAuth: true
        };
        props.changeLoader(true);
    
        let request = await API.service('openModalAddress', payload, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.data.data.content){
            if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
                let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                factors[props.content.customer_uuid] = request.data.data.content.uuid_factor;
                localStorage.factors = JSON.stringify(factors);
            }
            const as = <Modals.Factor
                intent="openModalAddress"
                contentModal={request.data.data.content}
                pos={props.pos}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                history={history}
                key="factor"
            />
            openlightbox(as);
        }else{
            viewEdit(data, type);
        }
        props.changeLoader(false);
        
    };

    const viewEdit = (data, type) => {
        const as = <Modals.Address
            contentModal={{
                stateCatalog: props.catalogs.states,
                countryCatalog: props.catalogs.country,
                changeWidgets: props.changeWidgets,
                widgets: props.widgets,
                address: data.address,
                geo: data.geo,
                customer_uuid: data.customer_uuid,
            }}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="address" />
        openlightbox(as);
    };

    const hasAction = (action) => {
        return props.config?.actions?.indexOf(action) > -1
    }

  	return <div className="size-6">
        <div className="tabBox card dataBlock">
            <div className="head flex align-center justify-between form-row">
                <i className="ibon-pin inb2 fx-elm-i col-ico" />
                <h3 className='col-8 fix-elm-title-widget'>Domicilio</h3>
                <div className='pnl-tooltip col-3 fix-dos-icos txt-right'>
                    {
                        hasAction('edit') &&
                        <Tooltip title="Editar">
                            <IconButton onClick={validation.bind(this, props.content, 'address')}>
                                <Edit/>
                            </IconButton>
                        </Tooltip>
                    }
                </div>                    
            </div>
            <br/>
            <ul>
                {
                    <li className={active == 'shipping' ? 'active' : ''} onClick={changeTab.bind(this, 'shipping')}>
                        De envío
                    </li>
                }
                {
                    <li className={active == 'invoicing' ? 'active' : ''} onClick={changeTab.bind(this, 'invoicing')}>
                        De facturación
                    </li>
                }
            </ul>

            { content['address'] && (active === 'shipping' ? content['address']['shipping'] : content['address']['invoicing']) &&
                <div className={'tabBoxContainer'}>
                    {
                        content['address'] && 
                        info.map((i) => {
                            if(content['address'][active][i.key]){
                                if(i.key === "street"){
                                    return (
                                        <div key={i.key} className='dataBlockItem'>
                                            <label className="neutral">{i.label}</label>
                                            <p>{content['address'][active][i.key]} No. {content['address'][active].intnum ? `ext. ${content['address'][active].extnum} int. ${content['address'][active].intnum}` : `ext. ${content['address'][active].extnum}`}</p>
                                        </div>
                                    )
                                } else if(i.key === "state"){
                                    return (
                                        <div key={i.key} className='dataBlockItem'>
                                            <label className="neutral">{i.label}</label>
                                            <p>{stateLabel[active]}</p>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={i.key} className='dataBlockItem'>
                                            <label className="neutral">{i.label}</label>
                                            <p>{content['address'][active][i.key]}</p>
                                        </div>
                                    )
                                }
                            }
                        })
                    }
                    {/* - Reference va solo en shipping? */}

                    <hr/>
                    {
                        content['geo'] && 
                        <div className="dataBlockItem">
                            <label className="neutral">Geolocalización apertura</label>
                            <p>{`@${props.content.geo.latitude},${props.content.geo.longitude}z`}</p>
                        </div>
                    }
                </div>
            }
            {
                content['address'] && (active === 'shipping' ? !content['address']['shipping'] : !content['address']['invoicing']) &&
                <div className={'tabBoxContainer'}>
                    Sin datos disponibles
                    <hr/>
                    {
                        content['geo'] && 
                        <div className="dataBlockItem">
                            <label className="neutral">Geolocalización apertura</label>
                            <p>{`@${props.content.geo.latitude},${props.content.geo.longitude}z`}</p>
                        </div>
                    }
                </div>
            }
            {
                props.content['address'] && props.content['address'][active] && props.content['address'][active]?.hasOwnProperty("not_match_mirai") && 
                <div className={'tabBoxContainer not_match'}>
                    <p style={{display: "flex"}}>
                        <ErrorOutline fontSize='small' style={{marginRight: "5px",}} />
                        <span>Campos existentes solo en Legacy</span>
                    </p>
                    {   props.content['address'][active]["not_match_mirai"] ? props.content['address'][active]["not_match_mirai"]?.fields.map((i) => {
                        return (
                            legacy.map((l) => {
                            if(i === l.key){
                               return (<label  key={i}>{l.label}</label>)
                            }
                        }))
                    })
                        :
                        <label>No aplica</label>
                    }
                </div>
            }
        </div>
    </div>
}

export default Address;